import { Endpoint, StatusCodeErrorList } from "./types/getErrorMessage"

export const getErrorMessage = (endpoint: string, statusCode: number) => {
	const endpointsList: Endpoint[] = [
		{
			endpoint: 'signin',
			statusCodeErrorList: [
				{
					statusCode: 400,
					errorList: [
						{
							text: 'La combinación de email y contraseña no es válida.'
						},
						{
							clickable: true,
							text: 'Te invitamos a recuperar contraseña aquí',
							href: '/recovery'
						}
					]
				},
				{
					statusCode: 401,
					errorList: [
						{
							text: 'Tu cuenta ha sido bloqueada por exceder los intentos de inicio de sesión.'
						},
						{
							clickable: true,
							text: 'Te invitamos a recuperar contraseña aquí',
							href: '/recovery'
						}
					]
				},
				{
					statusCode: 500,
					errorList: [
						{
							text: 'Nos ha sido difícil completar tu solicitud. Puedes resolverlo'
						},
						{
							clickable: true,
							text: 'contáctate a servicioalcliente@toctoc.com',
							href: 'mailto:servicioalcliente@toctoc.com'
						}
					]
				}
			]
		},
		{
			endpoint: 'signup',
			statusCodeErrorList: [
				{
					statusCode: 400,
					errorList: [
						{
							text: 'Los datos proporcionados están incompletos o son incorrectos. Por favor, revíselos.'
						},
					]
				},
				{
					statusCode: 401,
					errorList: [
						{
							text: 'Los datos ingresados ya están asociados a una cuenta existente.'
						},
						{
							clickable: true,
							text: 'Te invitamos a recuperar contraseña.',
							href: '#'
						}
					]
				},
				{
					statusCode: 500,
					errorList: [
						{
							text: 'Nos ha sido difícil completar tu solicitud. Puedes resolverlo'
						},
						{
							clickable: true,
							text: 'contáctate a servicioalcliente@toctoc.com',
							href: 'mailto:servicioalcliente@toctoc.com'
						}
					]
				}
			]
		},
		{
			endpoint: 'recovery',
			statusCodeErrorList: [
				{
					statusCode: 400,
					errorList: [
						{
							text: 'Nos ha sido difícil completar tu solicitud. Puedes resolverlo'
						},
						{
							clickable: true,
							text: 'contáctate a servicioalcliente@toctoc.com',
							href: 'mailto:servicioalcliente@toctoc.com'
						}
					]
				},
				{
					statusCode: 401,
					errorList: [
						{
							text: 'Tu cuenta se encuentra bloqueada por exceder los intentos de inicio de sesión.'
						},
						{
							clickable: true,
							text: 'Contáctate a servicioalcliente@toctoc.com',
							href: 'mailto:servicioalcliente@toctoc.com'
						}
					]
				},
				{
					statusCode: 404,
					errorList: [
						{
							text: 'Usuario no existe en nuestros registros.'
						},
						{
							clickable: true,
							text: 'Te invitamos a crear una cuenta.',
							href: '/signup'
						}
					]
				},
				{
					statusCode: 500,
					errorList: [
						{
							text: 'Nos ha sido difícil completar tu solicitud. Puedes resolverlo'
						},
						{
							clickable: true,
							text: 'contáctate a servicioalcliente@toctoc.com',
							href: 'mailto:servicioalcliente@toctoc.com'
						}
					]
				}
			]
		},
	]
	return endpointsList.find((x: Endpoint) => x.endpoint === endpoint)?.statusCodeErrorList?.find((y: StatusCodeErrorList) => y.statusCode === statusCode) ?? { errorList: [] };
}